import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useImageLibraryUploadHandler } from 'components/editor/ImageLibrary/useImageLibraryUploadHandler';
import FileUploadRoundedIcon from '@mui/icons-material/FileUploadRounded';

export function ThisDocumentImagesListEmptyState() {
  const { fileInputRef, handleClick, handleChange, accept } = useImageLibraryUploadHandler();

  return (
    <Stack direction="column" alignItems="center" justifyContent="center" height="100%" gap={3}>
      <Typography color="primary.main" variant="h6" fontWeight={600} textAlign="center">
        No uploads yet
      </Typography>
      <Typography color="primary.main" variant="body1" textAlign="center">
        Images you upload to this document will appear here.
      </Typography>
      <label htmlFor="upload-file">
        <input
          type="file"
          id="upload-file"
          onChange={handleChange}
          ref={fileInputRef}
          accept={accept}
          hidden
          multiple
          data-testid="file-input"
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleClick}
          startIcon={<FileUploadRoundedIcon />}
          sx={{ width: 'fit-content' }}
        >
          Upload
        </Button>
      </label>
    </Stack>
  );
}
